/**
 * Learning layer (CONCEPT.md §16): vocabulary cards, target words, writing
 * rules, the coach, points, and the profile. Routes in docs/api.md
 * ("Learning"); engine behaviour in docs/learning.md.
 *
 * Everything a player needs is authored at build time. Play never
 * generates a question; it only checks answers and asks the coach to judge
 * writing and word usage.
 */
export const DEFAULT_WRITING_RULES = {
    capitalization: "off",
    punctuation: "off",
    completeSentences: "off",
    person: { mode: "off", person: 1 },
    minWords: { mode: "off", count: 8 },
    noTextSpeak: "off",
    descriptive: "off",
    spelling: "off",
};
//# sourceMappingURL=learning.js.map